// Explicit zero must override the legacy switch. Old servers lack these fields.
export const resolvePasswordRestrictions = (settings = {}) => {
    const legacy = Number(settings.allow_elevated_privileges) === 1;
    return Object.fromEntries(
        ["discount", "price", "oth", "deferred", "cancellation"].map((action) => {
            const value = settings[`require_password_${action}`];
            return [action, value === undefined || value === null || value === ""
                ? legacy : Number(value) === 1];
        })
    );
};
